import { Component, Input, OnInit } from '@angular/core';
import { NavigationsFacade } from '@kion/data-access/data-access-navigations';
import { map } from 'rxjs/operators';
import { CmsPage, Navigation } from '@kion/data-models';
import { Observable } from 'rxjs';
import { NavBuilderService } from '../../../../../cms/src/lib/services/nav-builder.service';

@Component({
  selector: 'kion-category-navigation',
  templateUrl: './category-navigation.component.html',
  styleUrls: ['./category-navigation.component.scss']
})
export class CategoryNavigationComponent implements OnInit {

  @Input() page: CmsPage;
  @Input() noClose: boolean;
  @Input() title: string;
  @Input() single: boolean;

  nav$: Observable<Navigation>;

  display = 'block';

  constructor(private navigationsFacade: NavigationsFacade) { }

  ngOnInit(): void {
    const navBuilder = new NavBuilderService(this.navigationsFacade.all$);
    this.nav$ = navBuilder.findTree$(this.page.uid);
  }

  toggleTree() {
    if (this.display === "block") {
      this.display = 'none';
      return;
    }
    this.display = "block";
  }
}
